var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasItems)?_c('transition-group',{ref:"scroller",staticClass:"line-items"},_vm._l((_vm.lineItems),function(item){return _c('line-item',{key:item.id,attrs:{"item":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }